/* eslint-disable import/no-anonymous-default-export */
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import slide1 from "../../assets/foto1.png";
import slide2 from "../../assets/Violetaberisha.png";


import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default () => {
  const swiperRef = useRef<any>(null);
  const { t } = useTranslation("home");

  return (
    <div className="relative bg-dividers2 py-20">
      <div className="text-center mb-8">
        <p className="font-medium text-customRed mb-1 uppercase bg-dividers2">
          {t("board")}
        </p>
      </div>
      <div>
        <Swiper
          ref={swiperRef}
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          navigation={true}
          spaceBetween={20}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            470: {
              slidesPerView: 1.5,
            },
            640: {
              slidesPerView: 2,
            },
            857: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 2,
            },
            1256: {
              slidesPerView: 2,
            },
            1512: {
              slidesPerView: 2,
            },
          }}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
        >
          <SwiperSlide>
            <img
              src={slide1}
              alt="Slide 1"
              className="w-full h-[536px] 2xl:h-[636px] object-cover"
            />
            <div className="absolute bottom-0 w-full h-[70%] bg-gradient-to-t from-text via-slide to-transparent text-white flex flex-col items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
              <h3 className="text-lg font-semibold uppercase">Dr. Jonela Hoxhaj</h3>
              <p className="text-sm">1. Vorstand </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={slide2}
              alt="Slide 2"
              className="w-full h-[536px] 2xl:h-[636px] object-cover"
            />
            <div className="absolute bottom-0 w-full h-[70%] bg-gradient-to-t from-text via-slide to-transparent text-white flex flex-col items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
              <h3 className="text-lg font-semibold uppercase">Vijoleta Berisha </h3>
              <p className="text-sm"> Stellvertretende Vorsitzende</p>
            </div>
          </SwiperSlide>
          
        </Swiper>
      </div>
    </div>
  );
};
